import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CreateAssignmentOptions } from 'src/app/Elearning-Models';
import { ToastrService } from 'ngx-toastr';
import { GradebookDataService } from 'src/app/Services/gradebookData.service';
import { IServiceFactory } from 'src/app/Services/service-factory';

@Component({
  selector: 'app-advance-assign-dialog',
  templateUrl: './advance-assign-dialog.component.html',
  styleUrls: ['./advance-assign-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvanceAssignDialogComponent implements OnInit {
  valueUpdated = new EventEmitter<any>();
  arrAssignment: any;
  dataService: GradebookDataService;
  assignmentDefaults: CreateAssignmentOptions = {StartDate: new Date(), EndDate: new Date(), RemoveExtendedResponse: false,
    AssignOnlyUnassignedStudents: false};
  comment: string;
  arrClasses = [];
  selectedStudent = [];
  selectedClass: any;
  title = 'Assignment Details';
  checkboxes = { color: 'primary' };
  StartDate: any;
  EndDate: any;
  RemoveExtendedResponse = true;
  AssignOnlyUnassignedStudents = true;
  selectedClassess: any = [];
  isCaretDown = [true];
  isAdmin = false;
  arrAdminSelectedClasses = [];

  constructor(
    private serviceFactory: IServiceFactory,
    public dialogRef: MatDialogRef<AdvanceAssignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    // private dataService: GradebookDataService,
    private toastr: ToastrService
  ) {
    this.dataService = this.serviceFactory.getGradebookDataService();
    this.selectedStudent = [];
    this.arrAssignment = data.arrAssignment;
    // this.assignmentDefaults = data.assignmentDefaults;
    this.arrClasses = data.arrClasses;
    this.selectedStudent = data.selectedStudent;
    this.selectedClass = data.selectedClass;
    this.isAdmin = data.isAdmin;
  }

  ngOnInit(): void {
    this.getDefaultAssigments();
    this.StartDate = this.assignmentDefaults.StartDate;
    this.EndDate = this.assignmentDefaults.EndDate;
    this.RemoveExtendedResponse =
      this.assignmentDefaults.RemoveExtendedResponse;
    this.AssignOnlyUnassignedStudents =
      this.assignmentDefaults.AssignOnlyUnassignedStudents;
    this.arrClasses.forEach((sData) => {
      this.isCaretDown[sData.HBClassID] = true;
      if (this.selectedClass && this.selectedClass == sData.HBClassID) {
        sData.checked = true;
        if (this.selectedStudent.length > 0) {
          sData.Students.forEach((studentData) => {
            let isSelected = this.selectedStudent.find((temp) => {
              return temp == studentData.StudentID;
            });
            studentData.checked = false;
            if (isSelected) {
              studentData.checked = true;
            }
          });
        } else {
          sData.Students.forEach((studentData) => {
            studentData.checked = true;
          });
        }
        this.selectedClassess.push(sData);
      }
    });
  }

  /**
   * This method is called on click of Submit button of dialog.
   */
  onSubmit = () => {
    if(this.StartDate> this.EndDate) {
      this.toastr.warning('End Date should be greater than Start Date', 'Warning!');
      return;
    }
    let arrAssignedAssignmentsId = [];
    let arrClassStudent = [];
    this.arrAssignment.forEach((data) => {
      if (data.selected) {
        arrAssignedAssignmentsId.push(data.assignmentIDs[0]);
      }
    });
    if (arrAssignedAssignmentsId.length === 0) {
      this.toastr.warning('Assignment Lessons is Required', 'Warning!');
      return;
    }
    this.selectedClassess.forEach((sData) => {
      let arrStudentId = [];
      sData.Students.forEach((stuData) => {
        if (stuData.checked) {
          arrStudentId.push(stuData.StudentID);
        }
      });
      arrClassStudent.push({
        classIDs: sData.HBClassID,
        StudentIDs: arrStudentId,
      });
    });
    if (arrClassStudent.length === 0) {
      this.toastr.warning('Class is Required', 'Warning!');
      return;
    }
    let createdParams = {
      AssignmentIDs: arrAssignedAssignmentsId,
      RemoveExtendedResponse: this.RemoveExtendedResponse,
      AssignOnlyUnassignedStudents: this.AssignOnlyUnassignedStudents,
      StartDate: this.StartDate,
      EndDate: this.EndDate,
      Classes: arrClassStudent,
    };
    this.valueUpdated.emit(createdParams);
    this.dialogRef.close();
  };

  onCancel = () => {
    this.dialogRef.close();
  };

  /**
   * This method is called on change of classes dropdown to get checkbox selected.
   */
  changeClassSelection = (selectedData): void => {
    if (!this.isAdmin) {
      selectedData.value.forEach((sData) => {
        if (!sData.checked) {
          sData.checked = true;
          if (this.selectedStudent.length > 0) {
            sData.Students.forEach((studata) => {
              let isSelected = this.selectedStudent.find((temp) => {
                return temp == studata.StudentID;
              });
              if (isSelected) {
                studata.checked = true;
              }
            });
          } else {
            sData.Students.forEach((studentData) => {
              studentData.checked = true;
            });
          }

        }
      });
      this.arrClasses.forEach((cData) => {
        let isSelected = selectedData.value.find((temp) => {
          return temp.HBClassID === cData.HBClassID;
        });
        if (!isSelected) {
          cData.checked = false;
          cData.Students.forEach((selData) => {
            selData.checked = false;
          });
        }
      });
    } else {
      this.GetClassesWithStudent(selectedData);
    }
  };

  /**
   * This method is called on click of Checkbox of classes & also to unselect from dropdown.
   */
  changeClassCheckboxValue = (selectedData): void => {
    if (!selectedData.checked) {
      if(!this.isAdmin) {
        selectedData.Students.forEach((selData) => {
          selData.checked = false;
        });
      } else {
        selectedData.Students = [];
      }

      let arrTemp = [...this.selectedClassess];
      this.selectedClassess.forEach((classData, index) => {
        if (classData.HBClassID === selectedData.HBClassID) {
          arrTemp.splice(index, 1);
        }
      });
      setTimeout(() => {
        this.selectedClassess = arrTemp;
      }, 300);
    }
  };

  /**
   * This method is used to get list of array of classWithStudent.
   */
  GetClassesWithStudent = (selectedData) => {
    selectedData.value.map((sData) => {
      if (!sData.checked) {
        sData.checked = true;
        this.dataService
          .GetClassWithStudents(parseInt(selectedData.HBClassID, 10))
          .subscribe((res) => {
            sData.Students = res.Students;
            // sData.Students.forEach((studata) => {
            //   if (!studata.checked) {
            //     studata.checked = true;
            //   }
            // });
            if (this.selectedStudent.length > 0) {
              sData.Students.forEach((studata) => {
                let isSelected = this.selectedStudent.find((temp) => {
                  return temp == studata.StudentID;
                });
                if (isSelected) {
                  studata.checked = true;
                }
              });
            } else {
              sData.Students.forEach((studentData) => {
                studentData.checked = true;
              });
            }
          });
      }
    });
    this.arrClasses.forEach((cData) => {
      let isSelected = selectedData.value.find((temp) => {
        return temp.HBClassID === cData.HBClassID;
      });
      if (!isSelected) {
        cData.checked = false;
        cData.Students.forEach((selData) => {
          selData.checked = false;
        });
      }
    });
  };

  getDefaultAssigments = (): void => {
    this.dataService.GetDefaultAssignmentOptions().subscribe((res: CreateAssignmentOptions) => {
      this.assignmentDefaults = res;
    })
  }
}
